import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 8.33334V10.0042L10.8333 10.8333",
      stroke: "white",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("rect", {
      x: "7",
      y: "3.75",
      width: "6",
      height: "12.5",
      rx: "3",
      stroke: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.5 5L12.3298 4.18282C12.1207 3.1793 12.0162 2.67754 11.7187 2.36753C11.6858 2.33325 11.6515 2.30106 11.6158 2.27109C11.293 2 10.862 2 10 2C9.138 2 8.707 2 8.38422 2.27109C8.34853 2.30106 8.31418 2.33325 8.28129 2.36753C7.98385 2.67754 7.87931 3.1793 7.67025 4.18282L7.5 5",
      stroke: "white",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.5 15L7.67025 15.8172C7.87931 16.8207 7.98384 17.3225 8.28129 17.6325C8.31418 17.6668 8.34853 17.6989 8.38422 17.7289C8.707 18 9.138 18 10 18C10.862 18 11.293 18 11.6158 17.7289C11.6515 17.6989 11.6858 17.6668 11.7187 17.6325C12.0162 17.3225 12.1207 16.8207 12.3298 15.8172L12.5 15",
      stroke: "white",
      "stroke-linecap": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }